import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-website-header',
  templateUrl: './website-header.component.html',
  styleUrls: ['./website-header.component.css']
})
export class WebsiteHeaderComponent implements OnInit {

  audioSource: string = '../../../../assets/website-assets/ringtone-shankh-1101.mp3';
  constructor() { }

  ngOnInit() {
    this.playAudio()
  }

  hideDropdown: boolean = true;

  playAudio() {
    const audio = new Audio(this.audioSource);
    audio.autoplay = true;
    audio.loop = true;

    audio.addEventListener('play', () => {
      //console.log('Audio played successfully');
    });

    audio.addEventListener('error', (error) => {
      //console.error('Error playing audio:', error);
    });
  }
  
}
